import {
  ElInput, 
  ElInputNumber, 
  ElTooltip, 
  ElPopover, 
  ElDivider, 
  ElSwitch,
  ElDatePicker,
  ElSelect,
  ElOption,
  ElRadio,
  ElTable,
  ElTableColumn,
  ElButton,
  ElDropdownMenu,
  ElDropdown,
  ElTabs,
  ElTabPane,
  ElImage,
  ElUpload,
  ElCollapse,
  ElTag,
  ElRadioGroup,
  ElRadioButton,
  ElConfigProvider,
} from 'element-plus';


export function ElementSetup(app) {
  app.use(ElInput);
  app.use(ElInputNumber);
  app.use(ElTooltip);
  app.use(ElPopover);
  app.use(ElDivider);
  app.use(ElSwitch);
  app.use(ElDatePicker);
  app.use(ElSelect);
  app.use(ElOption);
  app.use(ElRadio);
  app.use(ElTable);
  app.use(ElTableColumn);
  app.use(ElButton);
  app.use(ElDropdownMenu);
  app.use(ElDropdown);
  app.use(ElTabs);
  app.use(ElTabPane);
  app.use(ElImage);
  app.use(ElUpload);
  app.use(ElCollapse);
  app.use(ElTag);
  app.use(ElRadioGroup);
  app.use(ElRadioButton);
  app.use(ElConfigProvider);
}